import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
  IconButton,
  TextField,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

const SaveAsNewDialog = ({ isOpen, setOpenSaveAsNewModal, onClose, onSubmit }) => {
    const [versionName, setVersionName] = React.useState("Budget_september");
  const handleClose = () => {
    setOpenSaveAsNewModal(false);
    if (onClose) onClose();
  };

  const handleSubmit = () => {
    if (onSubmit) onSubmit();
    handleClose(); // Close the modal after submit action if required
  };

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        fullWidth maxWidth="sm">
        
        <DialogTitle
        sx={{
            padding: "16px 16px 16px 16px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
        }}
        >
            <Box>
                <Typography
                variant="h4"
                sx={{
                    fontSize: "20px",
                    fontWeight: 700,
                    color: "#212B36",
                }}>
                    Save as new version
                </Typography>
            </Box>
            <IconButton onClick={handleClose}>
                <ClearIcon sx={{ width: "16px", height: "16px" }} />
            </IconButton>
        </DialogTitle>

        <DialogContent sx={{ padding: "16px" }}>
            <Typography
                sx={{
                color: "#637381",
                fontSize: "14px",
                fontWeight: 400,
                paddingBottom: "16px"
                }}
            >
                *Required fields
            </Typography>
            <Box>
                <TextField
                    fullWidth
                    label="New version name*"
                    name="New version name"
                    variant="outlined"
                    size="small"
                    value={versionName}
                    onChange={(event)=>{
                        const val = event.target.value;
                        setVersionName(val);
                    }}
                />
            </Box>
        </DialogContent>

        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "16px",
          }}>
          <Button
            onClick={handleClose}
            variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            disabled={!versionName.trim()}
            >
            Save as new version
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SaveAsNewDialog;
